import React, { useState } from 'react';
import './MuteBotSelector.pcss';
import { OnClickElsewhere } from '../../../../../common/components/OnClickElsewhere/OnClickElsewhere';

type Props = {
  onSelectTime(value: number): void;
  isIndefinitely: boolean;
  mutedSecondsRemaining?: number;
};
const useComponentStateAndHandlers = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  return {
    isDropdownOpen,
    setIsDropdownOpen,
  };
};

export const extraPauseInterval = [
  { duration: 0.25, text: '+15 seconds' },
  { duration: 1, text: '+1 minute' },
  { duration: 5, text: '+5 minutes' },
  { duration: 10, text: '+10 minutes' },
  { duration: 30, text: '+30 minutes' },
  { duration: 60, text: '+1 hour' },
  { duration: 180, text: '+3 hours' },
  { duration: 1440, text: '+1 day' },
  { duration: 9999999, text: 'Forever' },
];

export const MuteBotSelector = (props: Props) => {
  const { onSelectTime, isIndefinitely, mutedSecondsRemaining } = props;
  const { isDropdownOpen, setIsDropdownOpen } = useComponentStateAndHandlers();

  const handleOnSelectTime = (value: number) => {
    let muteFor = value * 60;
    if (!isIndefinitely) {
      muteFor += mutedSecondsRemaining || 0;
    }
    onSelectTime(muteFor);
    setIsDropdownOpen(false);
  };

  return (
    <>
      <div
        className="lc-mute--selector"
        onClick={() => setIsDropdownOpen(true)}
      >
        <div className="lc-mute--selector__indicator">
          <i className="lc-mute-selector__select-time fas fa-plus-circle" />
        </div>
      </div>

      {isDropdownOpen && (
        <OnClickElsewhere
          handleClick={() => setIsDropdownOpen(false)}
          className="lc-mute-selector--dropdown-time"
        >
          {extraPauseInterval.map(i => {
            return (
              <div
                key={i.text}
                className="lc-mute-selector--dropdown-time-value"
                onClick={() => handleOnSelectTime(i.duration)}
              >
                {i.text}
              </div>
            );
          })}
        </OnClickElsewhere>
      )}
    </>
  );
};
